<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>新增用户</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="back">返回</el-button>
      </div>
      <el-form label-position="right" label-width="80px" class="form">
        <el-form-item label="昵称" class="box">
          <el-input v-model="userData.nickName"></el-input>
        </el-form-item>
        <el-form-item label="姓名" class="box">
          <el-input v-model="userData.userName"></el-input>
        </el-form-item>
        <el-form-item label="手机号" class="box">
          <el-input v-model="userData.mobile"></el-input>
        </el-form-item>
        <el-form-item label="性别" class="box">
          <el-input v-model="userData.sex"></el-input>
        </el-form-item>
        <el-form-item label="地址" class="box">
          <el-input v-model="userData.addr"></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button class="saveBtn" @click="commit" type="primary">保存</el-button>
        <el-button class="saveBtn" @click="back" type="primary">返回</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";
export default {
  data() {
    return {
      userData: {
        nickName: "",
        userName: "",
        mobile: "",
        addr: "",
        sex: ""
      },
      loading: false,
      userId: this.$route.query.id
    };
  },
  mounted() {
    if(this.userId) {
      this.getUser();
    }
  },
  methods: {
    commit() {
      var that = this;
      let id = this.$route.query.id;
      var url = ''
      if(that.userId) {
        url = that.baseUrl + "/modifyUser"
        // url = "/gymTest/modifyUser"
      }else {
        url = that.baseUrl + "/saveUser"
        // url = "/gymTest/saveUser"
      }
      if (
        that.userData.userName &&
        that.userData.mobile 
      ) {
        that
          .$confirm("请确认用户信息是否正确？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          })
          .then(() => {
            that.$axios
              .post(url, {
                nickName: that.userData.nickName,
                userName: that.userData.userName,
                mobile: that.userData.mobile,
                addr: that.userData.addr,
                sex: that.userData.sex,
                id: that.userData.id
              })
              .then(res => {
                console.log(res);
                if (res.data.code == 0) {
                  that.$notify({
                    title: "保存成功",
                    message: "已成功保存用户！",
                    type: "success"
                  });
                  that.$router.go(-1);
                } else {
                  that.$notify.error({
                    title: "保存失败",
                    message: res.data.message
                  });
                }
              })
              .catch(error => {
                console.log(error);
              });
          });
      } else {
        that.$notify.error({
          title: "保存失败",
          message: "请填写姓名和手机号"
        });
      }
    },
    back() {
      this.$router.go(-1);
    },
    //获取用户详情
    getUser() {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/queryWxUser", {
        // .get("/gymTest/queryWxUser", {
          params: {
            userId: that.userId
          }
        })
        .then(res => {
          that.userData = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  components: {
    ToolBar,
    HelpHint
  }
};
</script>
<style scoped>
.form {
  overflow: hidden;
}
.box {
  width: 48%;
  float: left;
}
.wd50 {
  width: 47%;
}
.wd100 {
  width: 100%;
}
.mr {
  margin-right: 6%;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.btn-box {
  text-align: center;
  margin: 20px auto;
}
</style>
